<template>
  <div class="Reports__View">
    <EntityListLayout v-if="tabs.length" :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>שאלות חשיפה לפרק {{ expoChapter.displayName }}</template>
      <template #button>
        <div style="display: flex; align-items: center; gap: 10px;">
          <a class="button-close" @click="createExerciseFromExpo">צור כתרגול רב ברירה</a>
          <a @click="addExpoChapterQuestion" class="link-button">
            הוספת שאלות חשיפה לפרק
          </a>
        </div>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import CoursesService from "@/services/CoursesService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import ExpoChapterQuestionEntity from "@/views/ExpoChapterQuestionEntity.vue";
import DialogCreateExerciseFromExpo from '@/components/DialogCreateExerciseFromExpo.vue';
import DialogAddExpoChapterQuestion from '@/components/DialogAddExpoChapterQuestion.vue';
import { mapActions } from "vuex";
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import FieldService from "@/services/FieldService";
import { saveAs } from "file-saver";

export default {
  name: "Reports",
  data() {
    return {
      tabs: [],
      isStatistics: false
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
    expoChapter() {
      return this.$store.state.expoChapter;
    },
  },
  created() {
    this.init();
    this.create();
  },
  methods: {
    ...mapActions({
      load: "expoChapter/loadExpoChapter",
    }),
    async init(callback) {
      try {
        await this.load({
          id: this.$route.params.id,
        });
        if (callback) {
          callback();
        }
      } catch (err) {
        console.log(err);
      }
    },
    create() {
      const lessonsFields = FieldService.list("expoChapterQuestions");

      const sideViewEntity = {
        component: ExpoChapterQuestionEntity,
        preview: true,
        readOnly: !this.isAdmin,
        title: "פרטי שאלת חשיפה",
        recordUrl: "videos",
        recordTitle: "הצג סרטון",
        hideRecord: true
      };

      const excelExport = [
        {
          title: "יצוא טבלה",
          action: this.export,
        },
        {
          title: "סדר תווית שאלות פעילות מחדש",
          action: this.calculateUnitDisplay,
        },
        {
          title: "מחיקת כל שאלות הפרק",
          action: this.deleteQuestions,
        },
        {
          title: "הצג/הסתר סטטיסטיקה",
          action: this.showStatistics,
        },
      ];
      const fields = [
        { ...lessonsFields.Id, checked: true },
        { ...lessonsFields.UnitDisplayName, checked: true },
        { ...lessonsFields.Question, checked: true },
        { ...lessonsFields.Answer, checked: true },
        { ...lessonsFields.DetailedAnswer, checked: true },
        { ...lessonsFields.Status, checked: true },
        { ...lessonsFields.Count, checked: true },
        { ...lessonsFields.CorrectPercent, checked: true },
      ];

      this.tabs = [
        {
          id: "AllExpoChapterQuestions",
          isPrimary: true,
          title: "כל שאלות החשיפה לפרק",
          getDataAsync: this.getAllExpoChapterQuestions,
          perPage: 100,
          fields,
          filters: null,
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: false,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש לפי מזהה יחידה",
          },
          sideViewEntity,
        },
      ];
    },
    addExpoChapterQuestion() {
      Modal.open({
        component: DialogAddExpoChapterQuestion,
        props: {
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
    createExerciseFromExpo() {
      Modal.open({
        component: DialogCreateExerciseFromExpo,
        props: {
          store: this.$store,
          router: this.$router
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    export({ loading, query }) {
      loading(true);
      CoursesService.exportExpoChapterQuestions(this.$route.params.id, query)
        .then((r) => {
          this.saveFile(r.data, `ייצוא ${this.expoChapter.displayName}`);
        })
        .finally(() => {
          loading(false);
        });
    },
    calculateUnitDisplay({ loading, query }) {
      loading(true);
      CoursesService.resetQuestionsLabel(this.$route.params.id)
        .then(() => {
          // this.getAllExpoChapterQuestions(query);
          window.location.reload();
          loading(false);
        })
    },
    deleteQuestions({ loading, query }) {
      loading(true);
      CoursesService.deleteExpoChapterQuestions(this.$route.params.id)
        .then(() => {
          // this.tabs[0].getDataAsync();
          window.location.reload();
          loading(false);
        });
    },
    showStatistics({ loading, query, getData, setFields}){
      this.isStatistics = !this.isStatistics;
      if (this.isStatistics) {
        setFields(['id', 'unitDisplayName', 'question', 'answer', 'detailedAnswer', 'status', 'count', 'percent']);
      };
      getData(this.tabs[0]);
    },
    getAllExpoChapterQuestions({ ...rest }) {
      return CoursesService.getExpoChapterQuestion(this.$route.params.id, rest, this.isStatistics).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
    saveFile(data, filename) {
      const blob = new Blob([data], { type: this.excelMimeType });
      saveAs(blob, `${filename}.xlsx`);
    },
  },
};
</script>
<style scoped lang="scss">
.link-button {
  background: #00427e;
  border: none;
  border-radius: 3px;
  padding: 14px 25px;
  color: white;
  cursor: pointer;
}

.button-close {
  background: white;
  color: #00427e;
  border: none;
  border: 1px solid #00427e;
  padding: 13px 30px;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
}
</style>
